export const cancellationReasons = [
  'A pedido do segurado',
  'Apólice com dados incorretos',
  'Cliente desistiu do seguro',
  'Fechou com outra seguradora'
];
